import { db } from './firebase';
import { ref, set } from 'firebase/database';

// Mode d'affichage -> chemin Firebase de la collection éditable.
const PATHS = {
  films: 'categories',
  livres: 'books',
};

export function isEditableMode(mode) {
  return Boolean(PATHS[mode]);
}

// Écrit la collection complète (tableau de { name, films }) pour un mode donné.
export function saveCollection(mode, collection) {
  const path = PATHS[mode];
  if (!path) return Promise.reject(new Error(`Mode non éditable : ${mode}`));
  return set(ref(db, path), collection);
}

// Déplace un élément d'un tableau (renvoie une copie ; no-op si hors limites).
export function moveInArray(arr, index, dir) {
  const target = index + dir;
  if (target < 0 || target >= arr.length) return arr;
  const copy = [...arr];
  [copy[index], copy[target]] = [copy[target], copy[index]];
  return copy;
}
